import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";
import { SchemaMarkup } from "@/components/blog/SchemaMarkup";
import { generateBreadcrumbSchema } from "@/lib/breadcrumbSchemaGenerator";

interface BreadcrumbItem {
  name: string;
  url: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export const Breadcrumbs = ({ items }: BreadcrumbsProps) => {
  const allItems = [{ name: "Home", url: "/" }, ...items];

  return (
    <>
      <SchemaMarkup schema={generateBreadcrumbSchema(allItems)} />
      <nav aria-label="Breadcrumb" className="mb-4">
        <ol className="flex items-center gap-2 text-sm text-muted-foreground">
          {allItems.map((item, index) => (
            <li key={item.url} className="flex items-center gap-2">
              {index > 0 && <ChevronRight className="h-4 w-4" />}
              {index === allItems.length - 1 ? (
                <span className="text-foreground font-medium truncate max-w-[200px] sm:max-w-none" aria-current="page">
                  {item.name}
                </span>
              ) : (
                <Link
                  to={item.url}
                  className="hover:text-foreground transition-colors flex items-center gap-1"
                >
                  {index === 0 && <Home className="h-4 w-4" />}
                  <span className="hidden sm:inline">{item.name}</span>
                </Link>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
};
